@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  cdkDrag
  class="add_edit_common_main popup_main_div add_edit_safecustody_main"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>{{ dialogTitle }}</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form
        fxLayout="column"
        fxFlex="1 0 auto"
        name="SafeCustody"
        id="SafeCustody"
        [formGroup]="SafeCustody"
        class="one"
      >
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.SHORTNAME,'has-warning':errorWarningData.Warning?.SHORTNAME}">
          <mat-label>{{barristerTitle}}</mat-label>
          <input matInput  matTooltip="{{(toolTipList)?toolTipList.SHORTNAME:''}}" [matTooltipPosition]="toolTipPostion"  formControlName="SHORTNAME" readonly>
        </mat-form-field> -->

          <mat-form-field
            appearance="outline"
            fxFlex="50"
            class="pr-1"
            [ngClass]="{
              'menu-disabled': isDisabled,
              'has-error': $safeNavigationMigration(errorWarningData.Error?.SHORTNAME),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SHORTNAME),
            }"
          >
            <mat-label>Matters</mat-label>
            <mat-chip-grid #chipList aria-label="Matter selection">
              @for (matterdata of mattername; track matterdata) {
                <mat-chip-row (removed)="remove(matterdata)" class="mat-chips-selected">
                  {{ matterdata | slice: 0 : 40 }}
                  @if (matterdata.length > 50) {
                    ...
                  }
                  <button matChipRemove class="canclebutton">
                    <mat-icon style="font-size: 18px !important">cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
              <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.SHORTNAME?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                (keydown.Tab)="datashow($event)"
                formControlName="SHORTNAME"
                #MatterInput1
                [matAutocomplete]="autoMatter"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)"
                (keyup)="onKeyUp($event)"
                [ngClass]="mattername.length > 0 ? 'hideInput' : 'showInput'"
                [disabled]="hide"
              />
            </mat-chip-grid>
            <mat-autocomplete
              #autoMatter="matAutocomplete"
              (optionSelected)="selectedValue($event)"
            >
              @for (data of matterlist; track data) {
                <mat-option
                  class="mat-option_1"
                  (click)="selectedmatterguid(data)"
                  value="{{ data.MATTERGUID }}"
                >
                  {{ data.SHORTNAME }}--{{ data.MATTER }}
                </mat-option>
              }
            </mat-autocomplete>
            <mat-icon
              [ngClass]="{
                'menu-disabled': isDisabled || SafeCustody.get('SHORTNAME')?.disabled,
              }"
              id="mattersnew"
              class=""
              matSuffix
              (click)="SelectMatter()"
            >
              <!-- <img src="assets/icons/web_app/icon_matter_d.ico"> -->
              <img
                src="assets/icons/web_app/Frame 36.svg"
                matTooltip="Select Matter"
                matTooltipPosition="above"
              />
            </mat-icon>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="{{
              action === 'new' ||
              action === 'new client' ||
              action === 'new matter' ||
              action === 'newlegal'
                ? 48
                : 50
            }}"
            [ngClass]="{
              'menu-disabled': isOwnerDisabled,
              'has-error': $safeNavigationMigration(errorWarningData.Error?.CONTACTNAME),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CONTACTNAME),
            }"
          >
            <mat-label>Owner</mat-label>
            <!-- <input matInput  matTooltip="{{(toolTipList)?toolTipList.CONTACTNAME?.HOVER:''}}" [matTooltipPosition]="toolTipPostion"  formControlName="CONTACTNAME" readonly matInput >
          <mat-icon class="" matSuffix (click)='SelectContact()'>
            <img src="assets/icons/web_app/icon_contact_d.ico" matTooltip="" matTooltipPosition="above">
          </mat-icon> -->
            <mat-chip-grid #chipListContact aria-label="Matter selection">
              @for (Contactdata of Contactname; track Contactdata) {
                <mat-chip-row (removed)="removeContact(Contactdata)" class="mat-chips-selected">
                  {{ Contactdata | slice: 0 : 40 }}
                  @if (Contactdata.length > 30) {
                    ...
                  }
                  <button matChipRemove class="canclebutton">
                    <mat-icon style="font-size: 18px !important">cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
              <input
                matInput
                (keydown.Tab)="Contactdatashow($event)"
                matTooltip="{{ toolTipList ? toolTipList?.CONTACTNAME?.HOVER : '' }}"
                formControlName="CONTACTNAME"
                #MatterInput2
                [matAutocomplete]="autoContact"
                [matChipInputFor]="chipListContact"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addContact($event)"
                (keyup)="onKeyUpOwner($event)"
                [ngClass]="Contactname.length > 0 ? 'hideInput' : 'showInput'"
              />
            </mat-chip-grid>
            <mat-autocomplete #autoContact="matAutocomplete">
              @for (ContactData of Contactlist; track ContactData) {
                <mat-option class="mat-option_1" (click)="selectedContact(ContactData)">
                  @if (ContactData && !ContactData?.CONTACTGUID && ContactData.CONTACTNAME) {
                    <span><b>Add</b></span>
                  }
                  &nbsp;
                  @if (ContactData && !ContactData?.CONTACTGUID && ContactData.CONTACTNAME) {
                    <span><b>"</b></span>
                  }
                  {{ ContactData.CONTACTNAME }}
                  @if (ContactData && !ContactData?.CONTACTGUID && ContactData.CONTACTNAME) {
                    <span><b>"</b></span>
                  }
                </mat-option>
              }
            </mat-autocomplete>
            <mat-icon
              matSuffix
              (click)="
                this.MatterInputContact && this.MatterInputContact.nativeElement.value == ''
                  ? SelectContact()
                  : ''
              "
              [ngClass]="
                appPermissions?.[3]?.Access == 0 ? 'disabled-click large-button' : 'large-button'
              "
            >
              <!-- <img src="assets/icons/web_app/icon_contact_d.ico"> -->
              @if (currentUser?.THEMECOLOUR == 'theme-default') {
                <img src="assets/icons/web_app/Contact Base Icon 1.svg" />
              }
              @if (currentUser?.THEMECOLOUR == 'theme-yellow-light') {
                <img src="assets/icons/web_app/Contact Base Icon 1.svg" />
              }
              @if (currentUser?.THEMECOLOUR == 'theme-blue-gray-dark') {
                <img src="assets/icons/web_app/Contact Base Icon 2.svg" />
              }
              @if (currentUser?.THEMECOLOUR == 'theme-pink-dark') {
                <img src="assets/icons/web_app/Contact Base Icon 2.svg" />
              }
            </mat-icon>
          </mat-form-field>

          <!-- <button mat-fab color="primary" class="add-contect-btn" *ngIf="action === 'new' || action === 'new client' || action === 'new matter' || action === 'newlegal'" (click)="selectNewContect()">
        <mat-icon class="add-icon">add</mat-icon>
      </button> -->

          @if (action === 'new') {
            <a
              role="button"
              class="iconbtn-plus plus-middle mr-4 cursor-pointer!"
              (click)="selectNewContect()"
            >
              <span class="mdc-button__label">
                @if (
                  action === 'new' ||
                  action === 'new client' ||
                  action === 'new matter' ||
                  action === 'newlegal'
                ) {
                  <mat-icon
                    [ngClass]="
                      appPermissions?.[3]?.Create == 0
                        ? 'disabled-click large-button'
                        : 'large-button'
                    "
                    (click)="
                      this.MatterInputContact && this.MatterInputContact.nativeElement.value == ''
                        ? selectNewContect()
                        : null
                    "
                  >
                    add_circle
                  </mat-icon>
                }
              </span>
            </a>
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="{{ flexSize }}"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.SAFECUSTODYPACKETGUID),
              'has-warning': $safeNavigationMigration(
                errorWarningData.Warning?.SAFECUSTODYPACKETGUID
              ),
            }"
          >
            <mat-label>Packet</mat-label>
            <mat-select formControlName="SAFECUSTODYPACKETGUID">
              @for (pakets of packetcustody; track pakets) {
                <mat-option [value]="pakets.SAFECUSTODYPACKETGUID">
                  {{ pakets.PACKETNUMBER }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- <button mat-fab color="primary" class="add-contect-btn" *ngIf="action === 'new' ||action === 'new client'|| action === 'edit' || action === 'new matter' || action === 'newlegal'" (click)="OpenPacket(this.action)">
      <mat-icon class="add-icon">add</mat-icon>
    </button> -->

          <a role="button" class="iconbtn-plus plus-middle mr-4 cursor-pointer!">
            <span class="mdc-button__label">
              @if (
                action === 'new' ||
                action === 'new client' ||
                action === 'edit' ||
                action === 'new matter' ||
                action === 'newlegal'
              ) {
                <mat-icon (click)="OpenPacket(this.action)">add_circle</mat-icon>
              }
            </span>
          </a>

          <mat-form-field
            appearance="outline"
            fxFlex="{{ flexSize }}"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.DOCUMENTTYPE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DOCUMENTTYPE),
            }"
          >
            <mat-label>Document Type</mat-label>

            <input
              type="text"
              placeholder="Seperator"
              matInput
              matTooltip="{{ toolTipList ? toolTipList?.SAFECUSTODYPACKETGUID?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
              formControlName="DOCUMENTTYPE"
              [matAutocomplete]="auto"
              (focus)="onDocumentTypeFocus()"
              (keyup)="onDocumentTypeSearch($event.target.value)"
            />
            <mat-autocomplete #auto="matAutocomplete">
              @for (val of filteredDocumentTypes; track val) {
                <mat-option [value]="val.LOOKUPFULLVALUE" class="custome-mat-option">
                  {{ val.LOOKUPFULLVALUE }}
                </mat-option>
              }
            </mat-autocomplete>
            <!-- <mat-select placeholder="Seperator" formControlName="DOCUMENTTYPE">
        <mat-option *ngFor="let val of documnettype" [value]="val.LOOKUPFULLVALUE">
        {{val.LOOKUPFULLVALUE}}</mat-option>
      </mat-select> -->
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1"
    [ngClass]="{'has-error':errorWarningData.Error?.DOCUMENTNAME,'has-warning':errorWarningData.Warning?.DOCUMENTNAME}">
    <mat-label>Document\Website</mat-label>
    <input matInput  matTooltip="{{(toolTipList)?toolTipList.PACKETDESCRIPTION:''}}" [matTooltipPosition]="toolTipPostion"  formControlName="DOCUMENTNAME">
  </mat-form-field> -->

          <mat-form-field
            appearance="outline"
            fxFlex="50"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.DOCUMENTNAME),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DOCUMENTNAME),
            }"
          >
            <mat-label>Document\Website</mat-label>
            <input
              [(ngModel)]="SafeCustodyADD.DOCUMENTNAME"
              formControlName="DOCUMENTNAME"
              matInput
              matTooltip="{{ toolTipList ? toolTipList?.DOCUMENTNAME?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            <mat-icon matSuffix [matMenuTriggerFor]="menu">
              <img
                src="assets/icons/web_app/Matter Folder Icon.svg"
                alt=""
                matTooltip="File Upload"
                matTooltipPosition="above"
                class="block h-full w-full"
              />
            </mat-icon>
          </mat-form-field>
          <mat-menu #menu="matMenu" xPosition="before" yPosition="above">
            <button (click)="documentRegPopup()" mat-menu-item>
              Choose from Document Register
            </button>
            <button (click)="uploader.click()" mat-menu-item>Choose from device</button>
          </mat-menu>
          <!-- File Upload hiddenfiled -->
          <input type="file" hidden #uploader (change)="selectDoc($event)" />

          <mat-form-field
            appearance="outline"
            fxFlex="50"
            class="example pr-1"
            appearance="outline"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.REMINDERDATE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REMINDERDATE),
            }"
          >
            <mat-label>Review Date</mat-label>
            <input
              matInput
              matTooltip="{{ toolTipList ? toolTipList?.REMINDERDATE?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
              [matDatepicker]="pickerREMINDERDATE"
              placeholder="Choose a date"
              (dateInput)="choosedDate('input', $event)"
              (dateChange)="choosedDate('change', $event)"
              formControlName="REMINDERDATETEXT"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerREMINDERDATE"></mat-datepicker-toggle>
            <mat-datepicker #pickerREMINDERDATE></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="100"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.SAFECUSTODYDESCRIPTION),
              'has-warning': $safeNavigationMigration(
                errorWarningData.Warning?.SAFECUSTODYDESCRIPTION
              ),
            }"
          >
            <mat-label>Description</mat-label>
            <input
              matInput
              matTooltip="{{ toolTipList ? toolTipList?.SAFECUSTODYDESCRIPTION?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
              formControlName="SAFECUSTODYDESCRIPTION"
            />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.ADDITIONALTEXT,'has-warning':errorWarningData.Warning?.ADDITIONALTEXT}">
  <mat-label>Text</mat-label>
  <textarea cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" matInput  matTooltip="{{(toolTipList)?toolTipList?.ADDITIONALTEXT?.HOVER:''}}" [matTooltipPosition]="toolTipPostion"  formControlName="ADDITIONALTEXT"></textarea>
</mat-form-field> -->

          <mat-form-field
            appearance="outline"
            fxFlex="100"
            class="full-width pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.ADDITIONALTEXT),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ADDITIONALTEXT),
            }"
          >
            <mat-label>Text</mat-label>

            <textarea
              matInput
              formControlName="ADDITIONALTEXT"
              rows="4"
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="10"
              (keydown.enter)="$event.stopImmediatePropagation()"
              [matTooltip]="
                toolTipList ? $safeNavigationMigration(toolTipList?.ADDITIONALTEXT?.HOVER) : ''
              "
              [matTooltipPosition]="toolTipPostion"
            ></textarea>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <button
            matButton="filled"
            class="mat-accent"
            [disabled]="
              isDisableCheckBtn ||
              (MOVEMENTTYPEData != 'Checked In' && MOVEMENTTYPEData != 'Return')
            "
            (click)="tabLable = 'Borrow'; setDataRow('Borrow')"
          >
            Borrow
          </button>
          <button
            matButton="filled"
            class="mat-accent"
            [disabled]="isDisableCheckBtn || MOVEMENTTYPEData != 'Borrowed'"
            style="margin-left: 8px"
            (click)="tabLable = 'Return'; setDataRow('Return')"
          >
            Return
          </button>
          <button
            matButton="filled"
            class="mat-accent"
            [disabled]="
              isDisableCheckBtn ||
              (MOVEMENTTYPEData != 'Checked In' && MOVEMENTTYPEData != 'Return')
            "
            style="margin-left: 8px"
            (click)="tabLable = 'Check Out'; setDataRow('Check Out')"
          >
            Check Out
          </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-tab-group mat-align-tabs="start">
            <mat-tab label="{{ tabLable }}">
              @if (tabLable == 'Borrow' || tabLable == 'Check Out' || tabLable == 'Return') {
                <div class="Pad_tab mt-4 gap-y-10 pt-10" fxLayout="column">
                  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field
                      appearance="outline"
                      fxFlex="50"
                      class="example pr-1"
                      appearance="outline"
                      [ngClass]="{
                        'has-error': $safeNavigationMigration(errorWarningData.Error?.MOVEMENTDATE),
                        'has-warning': $safeNavigationMigration(
                          errorWarningData.Warning?.MOVEMENTDATE
                        ),
                      }"
                    >
                      <mat-label>Date</mat-label>
                      <input
                        matInput
                        [matDatepicker]="picker1"
                        placeholder="Choose a date"
                        (dateChange)="choosedDateTab('change', $event)"
                        formControlName="MOVEMENTDATETEXT"
                      />
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field
                      appearance="outline"
                      fxFlex="50"
                      class="pr-1"
                      [ngClass]="{
                        'has-error': $safeNavigationMigration(errorWarningData.Error?.CONTACTNAME),
                        'has-warning': $safeNavigationMigration(
                          errorWarningData.Warning?.CONTACTNAME
                        ),
                      }"
                    >
                      <mat-label>Contact Name</mat-label>
                      <input
                        matInput
                        matTooltip="{{ toolTipList ? toolTipList?.CONTACTNAME?.HOVER : '' }}"
                        [matTooltipPosition]="toolTipPostion"
                        formControlName="MOVEMENTCONTACTNAME"
                      />
                    </mat-form-field>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.REASON,'has-warning':errorWarningData.Warning?.REASON}">
            <mat-label>Details</mat-label>
            <textarea cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" matInput  matTooltip="{{(toolTipList)?toolTipList?.REASON?.HOVER:''}}" [matTooltipPosition]="toolTipPostion"  formControlName="REASON"></textarea>
          </mat-form-field> -->
                    <mat-form-field
                      appearance="outline"
                      fxFlex="100"
                      class="full-width pr-1"
                      [ngClass]="{
                        'has-error': $safeNavigationMigration(errorWarningData.Error?.REASON),
                        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REASON),
                      }"
                    >
                      <mat-label>Details</mat-label>

                      <textarea
                        matInput
                        formControlName="REASON"
                        rows="4"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="3"
                        cdkAutosizeMaxRows="10"
                        (keydown.enter)="$event.stopImmediatePropagation()"
                        [matTooltip]="
                          toolTipList ? $safeNavigationMigration(toolTipList?.REASON?.HOVER) : ''
                        "
                        [matTooltipPosition]="toolTipPostion"
                      ></textarea>
                    </mat-form-field>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <button
                      matButton="filled"
                      class="mat-accent"
                      (click)="SaveSafeCustodyMoveMent()"
                      [disabled]="isspiner"
                    >
                      @if (isspiner) {
                        <mat-spinner
                          style="
                            zoom: 0.2;
                            position: absolute;
                            right: 0;
                            left: 0;
                            margin: auto;
                            top: 0;
                            bottom: 0;
                          "
                        ></mat-spinner>
                      }
                      Save
                    </button>
                    <button
                      matButton="tonal"
                      style="margin-left: 8px"
                      (click)="isDisableCheckBtn = false; tabLable = 'History'"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              }
              @if (tabLable == 'Check In') {
                <div class="Pad_tab mt-4" fxLayout="column">
                  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field
                      appearance="outline"
                      fxFlex="50"
                      class="example pr-1"
                      appearance="outline"
                      [ngClass]="{
                        'has-error': $safeNavigationMigration(errorWarningData.Error?.CHECKINDATE),
                        'has-warning': $safeNavigationMigration(
                          errorWarningData.Warning?.CHECKINDATE
                        ),
                      }"
                    >
                      <mat-label>Date</mat-label>
                      <input
                        matInput
                        matTooltip="{{ toolTipList ? toolTipList?.CHECKINDATE?.HOVER : '' }}"
                        [matTooltipPosition]="toolTipPostion"
                        [matDatepicker]="picker1"
                        placeholder="Choose a date"
                        (dateInput)="PersonDate('input', $event)"
                        (dateChange)="PersonDate('change', $event)"
                        formControlName="CHECKINDATETEXT"
                      />
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field
                      appearance="outline"
                      fxFlex="50"
                      class="pr-1"
                      [ngClass]="{
                        'has-error': $safeNavigationMigration(
                          errorWarningData.Error?.CHECKINCONTACTNAME
                        ),
                        'has-warning': $safeNavigationMigration(
                          errorWarningData.Warning?.CHECKINCONTACTNAME
                        ),
                      }"
                    >
                      <mat-label>Contact Name</mat-label>
                      <input
                        matInput
                        matTooltip="{{ toolTipList ? toolTipList?.CHECKINCONTACTNAME?.HOVER : '' }}"
                        [matTooltipPosition]="toolTipPostion"
                        formControlName="CHECKINCONTACTNAME"
                      />
                    </mat-form-field>
                  </div>
                </div>
              }
              @if (tabLable == 'History') {
                <div class="Pad_tab mt-4" fxLayout="column">
                  <div class="one content">
                    <div class="max-h-[calc(100dvh-260px)] overflow-auto">
                      <table
                        mat-table
                        [dataSource]="checkInData"
                        [@animateStagger]="{ value: '50' }"
                      >
                        <ng-container matColumnDef="MOVEMENTDATE">
                          <th mat-header-cell *matHeaderCellDef>Date</th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.MOVEMENTDATE }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="MOVEMENTTYPE">
                          <th mat-header-cell *matHeaderCellDef>Type</th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.MOVEMENTTYPE }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="CONTACTNAME">
                          <th mat-header-cell *matHeaderCellDef>Name</th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.CONTACTNAME }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="REASON">
                          <th mat-header-cell *matHeaderCellDef>REASON</th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.REASON }}
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr
                          mat-row
                          *matRowDef="let row; columns: displayedColumns"
                          (click)="
                            editCheckinData(row); highlightedRows = row.SAFECUSTODYMOVEMENTGUID
                          "
                          [style.background]="
                            highlightedRows == row.SAFECUSTODYMOVEMENTGUID ? selectedColore : ''
                          "
                          [ngClass]="
                            highlightedRows == row.SAFECUSTODYMOVEMENTGUID ? 'row-text-colore' : ''
                          "
                          [@animate]="{
                            value: '*',
                            params: { y: '100%' },
                          }"
                        ></tr>
                      </table>
                    </div>
                  </div>
                </div>
              }
            </mat-tab>
          </mat-tab-group>
        </div>
      </form>
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button matButton="filled" class="mat-accent" (click)="SaveSafeCustody()" [disabled]="isspiner">
      @if (isspiner) {
        <mat-spinner
          style="zoom: 0.2; position: absolute; right: 0; left: 0; margin: auto; top: 0; bottom: 0"
        ></mat-spinner>
      }
      Save
    </button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
